import { render, staticRenderFns } from "./userIntegralList.vue?vue&type=template&id=78f5b2d1&scoped=true"
import script from "./userIntegralList.vue?vue&type=script&lang=js"
export * from "./userIntegralList.vue?vue&type=script&lang=js"
import style0 from "./userIntegralList.vue?vue&type=style&index=0&id=78f5b2d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f5b2d1",
  null
  
)

export default component.exports